import * as React from 'react';

const DelayRendering = ({ children, delayMs = 5000 }: { children: React.ReactNode; delayMs?: number }) => {
  const [showComponents, setShowComponents] = React.useState(false);
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowComponents(true);
    }, delayMs);
    return () => clearTimeout(timer);
  }, [delayMs]);

  if (!showComponents) {
    return null;
  }

  return <>{children}</>;
};

export default DelayRendering;
